import { render, staticRenderFns } from "./SkipMobile.vue?vue&type=template&id=3936b052&scoped=true"
import script from "./SkipMobile.vue?vue&type=script&lang=js"
export * from "./SkipMobile.vue?vue&type=script&lang=js"
import style0 from "./SkipMobile.vue?vue&type=style&index=0&id=3936b052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3936b052",
  null
  
)

export default component.exports